/* Tout bouton de commande passe par l'etape Livraison du theme.
   Ecoute deleguee sur le document : le panier et le tiroir sont rendus
   a des moments differents, une liaison directe en raterait toujours un.
   Sans JavaScript, les formulaires partent directement chez Shopify. */
(function () {
  var NEXT = '/pages/livraison';

  document.addEventListener('click', function (e) {
    var go = e.target && e.target.closest ? e.target.closest('.ct-go, .cd-go') : null;
    if (!go || go.dataset.busy === '1') return;

    e.preventDefault();
    go.dataset.busy = '1';
    go.textContent = 'Un instant…';

    var note = document.getElementById('ct-note');
    var step = note
      ? fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note.value })
        }).catch(function () {})
      : Promise.resolve();

    step.then(function () { window.location.href = NEXT; });
  });
})();
